let TeamsStacks = {
    SET_EXPOSURE_MAX_OF_TEAM_STACKS: 'SET_EXPOSURE_MAX_OF_TEAM_STACKS',
    SET_EXPOSURE_MAX_OF_USED_TEAM: 'SET_EXPOSURE_MAX_OF_USED_TEAM',
};

export default TeamsStacks;
